import { StateWithCityOutputStateData } from './state-with-city-output-state-data.model';


export class StateSelectByIdOutput implements IStateSelectByIdOutput {
    status!: number;
    message!: string;
    data!: StateWithCityOutputStateData;

    constructor(data?: IStateSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? StateWithCityOutputStateData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StateSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StateSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IStateSelectByIdOutput {
    status: number;
    message: string;
    data: StateWithCityOutputStateData;
}

